import type * as React from 'react';

import { ChangeRequestChanges, type ChangeRequestChangesProps } from '../Changes';
import {
    ChangeRequestCommentsProvider,
    type ChangeRequestCommentsProviderProps,
} from './ChangeRequestCommentsProvider';
import { ChangeRequestDetails } from './ChangeRequestDetails';
import { ChangeRequestIntro, type ChangeRequestIntroProps } from './ChangeRequestIntro';

export type ChangeRequestOverviewProps = ChangeRequestCommentsProviderProps &
    ChangeRequestIntroProps &
    ChangeRequestChangesProps;

/**
 * Renders the change request overview.
 */
export function ChangeRequestOverview(props: ChangeRequestOverviewProps): React.ReactElement {
    return (
        <ChangeRequestCommentsProvider {...props}>
            <div className="@container flex flex-1 overflow-y-auto">
                <div className="flex flex-1 flex-col gap-8 overflow-y-auto pb-6">
                    <ChangeRequestIntro {...props} />
                    <div className="px-6 ">
                        <ChangeRequestChanges {...props} />
                    </div>
                </div>
                <ChangeRequestDetails {...props} />
            </div>
        </ChangeRequestCommentsProvider>
    );
}
